export enum Permission {
  ViewDocumentStatus = 'ViewDocumentStatus',
  ManageFolders = 'ManageFolders',
  ManageMainFolders = 'ManageMainFolders',
  UploadDocuments = 'UploadDocuments',
  ChangeDocumentStatus = 'ChangeDocumentStatus',
  DeleteDocument = 'DeleteDocument',
  CopyFolder = 'CopyFolder',
  CreateFullAdmin = 'CreateFullAdmin',
  DeleteFolder = 'DeleteFolder',
}
